import "../App.css"

import { DatePickerType, DrowpdownValue, InputControlType, MenuSelectType, MultiSelectType, TagType, ToggleButtonType } from "../types/FormTypes";
import { FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputLeftAddon, Select, Switch, Tag as TagComp, TagLabel, TagLeftIcon, TagRightIcon, Textarea } from "@chakra-ui/react";
import { ReactElement, useState } from "react";

import { Select as MultiSelectMenu } from "chakra-react-select";
import { RootState } from "src/store/store";
import { isEmailValid } from "src/utils/registrationFormUtils";
import { useSelector } from "react-redux";
import { Regisration_Form_Labels_English } from "./constants/englishLabels";
import { Regisration_Form_Labels_Hindi } from "./constants/hindiLabels";

export const InputControl = (props: InputControlType) => {
  const { value, englishLabel, placeholder, onChange, name, isMandatory, isValidate, isEmailId,
    isNumber, length, hindiLabel, isMobileNumber, isDisabled } = props;

  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const isError = isValidate && isMandatory && !value;
  const [isInValid, setIsInValid] = useState(false)

  const handleOnBlur = (): void => {

    if (isEmailId) {
      value ? setIsInValid(!isEmailValid(value?.toString() || "")) : setIsInValid(false)
    }

    if(isNumber && length && value){
      setIsInValid(value?.toString().length !== length)
    }
  }

  const handleValueChange = (newValue: string): void => {
    if (!name || !onChange) return;

    let filteredValue = newValue;

    if (isNumber) {
      // Allow only digits in the input
      filteredValue = length ? newValue.replace(/\D/g, '').slice(0, length) : newValue.replace(/\D/g, '');
    }

    onChange(name, filteredValue);
  };



  return (
    <FormControl isInvalid={isError || isInValid} isRequired={isMandatory}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}</FormLabel>
      <InputGroup>
        {isMobileNumber && <InputLeftAddon bg={value ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)"}>+91</InputLeftAddon>}
        <Input
          _placeholder={{ color: "rgba(108, 117, 125, 0.61)", fontWeight: 400 }}
          className="form-input"
          fontWeight={500}
          onBlur={handleOnBlur}
          bg={value ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)"}
          placeholder={placeholder} border="1px solid #D5DBE3"
          value={value}
          onChange={(event) => handleValueChange(event.target.value)}
          isDisabled={isDisabled}
        />
      </InputGroup>
      {isError && <FormErrorMessage>{isHindiLabels
      ? `${hindiLabel} ${Regisration_Form_Labels_Hindi.MANDATORY}`
      : `${englishLabel} ${Regisration_Form_Labels_English.MANDATORY}`}</FormErrorMessage>}
      {isInValid && <FormErrorMessage>{isHindiLabels ? hindiLabel : englishLabel} is Invalid</FormErrorMessage>}
    </FormControl>
  );
};

export const TextArea = ({ isDisabled, isMandatory, value, englishLabel, hindiLabel, name, onChange, isValidate, placeholder }: InputControlType): ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const isError = isValidate && isMandatory && !value
  return (
    <FormControl isInvalid={isError} isRequired={isMandatory}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}</FormLabel>
      <Textarea
        className="form-input"
        _placeholder={{ color: "rgba(108, 117, 125, 0.61)", fontWeight: 400 }}
        border="1px solid #D5DBE3"
        placeholder={placeholder}
        bg={value ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)"}
        value={value}
        onChange={(event) => onChange && name && onChange(name, event.target.value)}
        isDisabled={isDisabled}
      />
      {isError && <FormErrorMessage>{isHindiLabels
      ? `${hindiLabel} ${Regisration_Form_Labels_Hindi.MANDATORY}`
      : `${englishLabel} ${Regisration_Form_Labels_English.MANDATORY}`}</FormErrorMessage>}
    </FormControl>
  )
}

export const DatePicker = ({ hindiLabel, englishLabel, onDateChange, selectedDate, name, placeholder, isValidate, isMandatory }: DatePickerType): ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const isError = isValidate && isMandatory && !selectedDate;

  // Max date is one day before today (no future dates allowed)
  const getMaxDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0');
    const day = String(yesterday.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Realistic minimum date for DOB
  const getMinDate = () => {
    return `1900-01-01`;
  };

  const maxDate = getMaxDate();
  const minDate = getMinDate();
  const isOutOfRange = !!selectedDate && (selectedDate < minDate || selectedDate > maxDate);

  // Build display-friendly DD/MM/YYYY for max date
  const displayMaxDate = (() => {
    const [y, m, d] = maxDate.split('-');
    return `${d}/${m}/${y}`;
  })();

  const handleDateChange = (value: string) => {
    if (!name) return;
    // Always propagate the entered value so the component can render the proper error state
    // The FormControl will show out-of-range errors when selectedDate is invalid
    onDateChange(name, value);
  };

  return (
    <FormControl isRequired={isMandatory} isInvalid={isError || isOutOfRange}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}</FormLabel>
      <Input
        type="date"
        className="form-input"
        _placeholder={{ color: "rgba(108, 117, 125, 0.61)", fontWeight: 400 }}
        border="1px solid #D5DBE3"
        placeholder={placeholder}
        bg={selectedDate ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)"}
        value={selectedDate}
        onChange={(event) => handleDateChange(event.target.value)}
        max={maxDate}
        min={minDate}
        sx={{
          '&::-webkit-calendar-picker-indicator': {
            color: "black",
          },
        }}
      />
      {isError && <FormErrorMessage>{isHindiLabels
      ? `${hindiLabel} ${Regisration_Form_Labels_Hindi.MANDATORY}`
      : `${englishLabel} ${Regisration_Form_Labels_English.MANDATORY}`}</FormErrorMessage>}
      {isOutOfRange && (
          <FormErrorMessage>
            {`Please select a valid date between 01/01/1900 and ${displayMaxDate} in DD/MM/YYYY format.`}
          </FormErrorMessage>
      )}
    </FormControl>
  )
}

export const MenuSelect = ({ hindiLabel, englishLabel, value, values, name, placeholder, isMandatory, isValidate, onSelect, isDisabled }: MenuSelectType): ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const isError = isValidate && isMandatory && !value
  return (
    <FormControl isInvalid={isError} isRequired={isMandatory}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}</FormLabel>
      <Select
        className="form-input"
        _placeholder={{ color: "rgba(108, 117, 125, 0.61)", fontWeight: 400 }}
        border="1px solid #D5DBE3"
        bg={value ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)"}
        variant="filled"
        value={value}
        placeholder={placeholder}
        onChange={(event) => name && onSelect(name, event.target.value)}
        isDisabled={isDisabled}
      >
        {values.map((val, index) => <option key={index} value={val}>{val}</option>)}
      </Select>
      {isError && <FormErrorMessage>{isHindiLabels
      ? `${hindiLabel} ${Regisration_Form_Labels_Hindi.MANDATORY}`
      : `${englishLabel} ${Regisration_Form_Labels_English.MANDATORY}`}</FormErrorMessage>}
    </FormControl>
  )
}

export const ToggleSwitch = ({ name, value, isMandatory, hindiLabel, englishLabel, onChange, isValidate }: ToggleButtonType): ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const isError = isValidate && isMandatory && !value
  return (
    <FormControl isInvalid={isError} isRequired={isMandatory}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}
      </FormLabel>
      <Switch onChange={(event) => name && onChange(name, event.target.checked)} id={name} />
    </FormControl>
  )
}         

export const MultiSelect = ({ placeholder, name, onChange, dropdownValues, value, isMandatory, hindiLabel, englishLabel, isValidate }: MultiSelectType): ReactElement => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";
  const isError = isValidate && isMandatory && !value;
  const backgroundColor = value.length ? "rgba(108, 117, 125, 0.15)" : "rgba(108, 117, 125, 0.05)";
  const isFocused= (isfocused: boolean): string=>{
    return isfocused ? "1px solid #FF7E6B" : "1px solid #D5DBE3"
  }
  return (
    <FormControl isInvalid={isError} isRequired={isMandatory}>
      <FormLabel fontSize="16px" fontWeight={700} className="form-text">{isHindiLabels ? hindiLabel : englishLabel}</FormLabel>
      <MultiSelectMenu
        tagVariant="solid"
        closeMenuOnSelect={false}
        className="form-input"
        chakraStyles={{
          placeholder: (provided) => ({
            ...provided,
            color: "rgba(108, 117, 125, 0.61)",
            fontWeight: 400,
          }),
          control: (provided, state) =>{
          return ({
            ...provided,
            border: isFocused(state.isFocused),
            backgroundColor: backgroundColor,
            boxShadow: (): string=>state.isFocused ? "0 0 0 1px #FF7E6B" : "none",
            transition: "border-color 0.2s, box-shadow 0.2s",
          })
        },
          container: (provided) => ({
            ...provided,
            width: "100%",
          }),
        }}
        colorScheme="blackAlpha"
        placeholder={placeholder}
        isMulti
        value={value}
        onChange={(newValue) => name && onChange(name, newValue as DrowpdownValue[])}
        options={dropdownValues}
      />
      {isError && <FormErrorMessage>{isHindiLabels
      ? `${hindiLabel} ${Regisration_Form_Labels_Hindi.MANDATORY}`
      : `${englishLabel} ${Regisration_Form_Labels_English.MANDATORY}`}</FormErrorMessage>}
    </FormControl>
  );
};

export const Tag = ({ leftIcon, rightIcon, backgroundColor, size, borderRadius, label }: TagType): ReactElement => {
  return (
    <TagComp paddingInlineStart={1} borderRadius={borderRadius || "20px"} py={1} size={size || "sm"} backgroundColor={backgroundColor}>
      {leftIcon && <TagLeftIcon boxSize="12px" as={leftIcon} />}
      <TagLabel ml={1}>{label}</TagLabel>
      {rightIcon && <TagRightIcon boxSize="12px" as={rightIcon} />}
    </TagComp>
  )
}